/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PostApiV1SerieSerieidLangsMutationRequest,
  PostApiV1SerieSerieidLangsMutationResponse,
  PostApiV1SerieSerieidLangsPathParams,
  PostApiV1SerieSerieidLangs400,
  PostApiV1SerieSerieidLangs401,
  PostApiV1SerieSerieidLangs404,
  PostApiV1SerieSerieidLangs500,
} from "../../types/serieIdiomasController/PostApiV1SerieSerieidLangs.ts";

function getPostApiV1SerieSerieidLangsUrl(
  serieId: PostApiV1SerieSerieidLangsPathParams["serieId"],
) {
  const res = {
    method: "POST",
    url: `/api/v1/serie/${serieId}/langs` as const,
  };
  return res;
}

/**
 * @description Cria uma nova tradução (idioma) para a série. **(Requer Authorization para autenticação)**
 * @summary Criar idioma da série (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs}
 */
export async function postApiV1SerieSerieidLangs(
  serieId: PostApiV1SerieSerieidLangsPathParams["serieId"],
  data?: PostApiV1SerieSerieidLangsMutationRequest,
  config: Partial<RequestConfig<PostApiV1SerieSerieidLangsMutationRequest>> & {
    client?: Client;
  } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PostApiV1SerieSerieidLangsMutationResponse,
    ResponseErrorConfig<
      | PostApiV1SerieSerieidLangs400
      | PostApiV1SerieSerieidLangs401
      | PostApiV1SerieSerieidLangs404
      | PostApiV1SerieSerieidLangs500
    >,
    PostApiV1SerieSerieidLangsMutationRequest
  >({
    method: "POST",
    url: getPostApiV1SerieSerieidLangsUrl(serieId).url.toString(),
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
